/**
 * @generated SignedSource<<e31c6118014776fa63702ecdbdd2ab67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type UserRoleEnum = "admin" | "customer_success_rep" | "recruiter" | "sales" | "screening";
import { FragmentRefs } from "relay-runtime";
export type user_isRealAdmin$data = {
  readonly realUser: {
    readonly roles: ReadonlyArray<UserRoleEnum> | null | undefined;
  } | null | undefined;
  readonly roles: ReadonlyArray<UserRoleEnum> | null | undefined;
  readonly " $fragmentType": "user_isRealAdmin";
};
export type user_isRealAdmin$key = {
  readonly " $data"?: user_isRealAdmin$data;
  readonly " $fragmentSpreads": FragmentRefs<"user_isRealAdmin">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "user_isRealAdmin"
};

(node as any).hash = "5ad596703e4b63ca534292e0102a796a";

export default node;
